import React, { useEffect, useState } from "react";
import { useBranchManagement } from "./hooks/useBranchManagement";
import { useBranchForm } from "./hooks/useBranchForm";
import BranchToolbar from "./components/BranchToolbar";
import BranchList from "./components/BranchList";
import AddBranchModal from "./components/AddBranchModal";
import DeleteConfirmationModal from "./components/DeleteConfirmationModal";
import EditBranch from "./components/EditBranch";
import EditMenu from "../EditMenu";
import { useAddBranch } from "./hooks/useAddBranch";
import { useDeleteBranch } from "./hooks/useDeleteBranch";
import { PageTitle } from "src/shared/PageTitle";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { pageTitle } from "src/shared/utils/brand";
import { useUserTheme } from "src/shared/utils/useUserTheme";

const BranchesPage = () => {
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedBranchId, setSelectedBranchId] = useState<string | null>(null);

  const { branches, showDeletedBranches, handleCheckboxChange, deleteBranch, fetchBranches, loading } = useBranchManagement();

  const { formData, doberror, error, refs, updateFormData, resetForm, handleDobChange, handlePincodeChange, createKeyPressHandler, handleBranchnamesKeyPress } = useBranchForm();

  const { addBranch } = useAddBranch(resetForm, fetchBranches, () => setAddModalOpen(false));
  const { selectedDelBranchId, setSelectedDelBranchId, handleDelete, confirmDelete } = useDeleteBranch(deleteBranch, fetchBranches);
  const { sidebarThemeClass } = useUserTheme();

  const branchName = branches.find((b) => b._id.$oid === selectedDelBranchId)?.name || "";
  const visible = !!formData.name && !doberror;
  const menu = { Edit: "Edit" };

  useEffect(() => {
    document.title = pageTitle("Branches › Settings");
  }, []);

  return (
    <div className="p-1">
      <div className={`flex flex-col w-full h-[91vh] shadow-inner rounded-lg items-center ${sidebarThemeClass} overflow-hidden`}>
        <PageTitle title="- Settings › Branches" />
        <EditMenu editmenu={menu} />
        <BranchToolbar showDeletedBranches={showDeletedBranches} onCheckboxChange={handleCheckboxChange} onAddClick={() => setAddModalOpen(true)} />

      <BranchList
        branches={branches}
        showDeletedBranches={showDeletedBranches}
        onEdit={(branch) => {
          if (branch?._id?.$oid) {
            setSelectedBranchId(branch._id.$oid);
            setEditModalOpen(true);
          }
        }}
        onDelete={handleDelete}
      />

      <AddBranchModal
        open={addModalOpen}
        formData={formData}
        doberror={doberror}
        error={error}
        refs={refs}
        updateFormData={updateFormData}
        handleDobChange={handleDobChange}
        handlePincodeChange={handlePincodeChange}
        createKeyPressHandler={createKeyPressHandler}
        handleBranchnamesKeyPress={handleBranchnamesKeyPress}
        onClose={() => {
          setAddModalOpen(false);
          resetForm();
        }}
        onSubmit={() =>
          addBranch({
            branchName: formData.name,
            branchopeningdate: formData.openingDate,
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
            selectedCountry: formData.country,
            selectedState: formData.state,
            selectedCity: formData.city,
            Pincode: formData.postalCode,
          })
        }
        visible={visible}
      />

      {editModalOpen && selectedBranchId && <EditBranch id={selectedBranchId} closeEdit={() => setEditModalOpen(false)} fetchBranches={fetchBranches} />}

      <DeleteConfirmationModal open={!!selectedDelBranchId} onClose={() => setSelectedDelBranchId(null)} onConfirm={confirmDelete} branchName={branchName} />

      {loading && <LoadingScreen />}
      {/* <ToastContainer /> */}
    </div>
    </div>
    // </BusinessLayout>
  );
};

export default BranchesPage;
